import { Form } from './src/form';

export const FSForm = async (form, name) => {
  try {
    const fsform = await Form.create(form, name);
    fsform.dressForm();
  } catch (e) {
    console.log(`Error creating form dressings: ${e.message}`);
  }
};
